import get from 'lodash.get';

const getTermsUrl = (rootState) => get(rootState, 'user.partnerData.properties.tosUrl', null);

export default getTermsUrl;
